import { Link } from 'react-router-dom';
import cn from 'classnames';
import { Tooltip } from '@ds';
import { getReservationColors } from '@lp/features/Scheduler/utils';
import { SOrganGroup } from '@lp/features/Scheduler/SchedulerSurgeons/types';
import { ReservationNode } from '@/api/apis/resources';
import { reservationTypeNames } from '@/constants/resources.constants';
import { CaseResourceType } from '@/api/apis/case';
import { ReservationBarTooltip } from './ReservationBarTooltip';

type ReservationBarProps = {
  isRestReadOnly: boolean;
  data: ReservationNode;
  resourceType: CaseResourceType;
  organGroup?: SOrganGroup;
};

export const ReservationBar = ({ data, resourceType, organGroup, isRestReadOnly }: ReservationBarProps) => {
  const colors = getReservationColors(data);

  return (
    <Tooltip
      content={
        <ReservationBarTooltip
          data={data}
          resourceType={resourceType}
          organGroup={organGroup}
          isRestReadOnly={isRestReadOnly}
        />
      }
      offset={2}
      triggerScaleOnOpen={false}
      shouldCloseOnInteractOutside={() => false} // Due to it takes a child button click as outside interaction
    >
      <div className="flex justify-between w-full whitespace-nowrap gap-1">
        <span className={cn('text-xs-m', colors.text)}>{reservationTypeNames[data.type]}</span>
        <Link className={cn('text-xs-sb hover:underline', colors.organText)} to={`/case/${data.caseId}`}>
          {data.caseName}
        </Link>
      </div>
    </Tooltip>
  );
};
